import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Event = ({ event }) => {
  const specificUnixTime = event.timeOut; // Replace with your specific UNIX time
  const [isTimeExpired, setIsTimeExpired] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentTime = Math.floor(Date.now() / 1000);

      if (currentTime > specificUnixTime) {
        setIsTimeExpired(true);
        clearInterval(intervalId);
      } else {
        setIsTimeExpired(false);
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const eventStyle = {
    backgroundColor: 'white',
    borderRadius: '6px',
    padding: '20px',
    margin: '5px',
    textDecoration: 'none',
    color: 'inherit',
    maxWidth: '320px',
  };

  const buttonStyle = {
    width: '135px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 20px',
    cursor: 'pointer',
    fontSize: '16px',
    textDecoration: 'none',
    margin: '10px 100px',
  };

  return (
    <div style={{ textDecoration: 'none', color: 'inherit', margin: '10px 20px' }}>
      <div className="event" style={eventStyle}>
        <h2 style={{ textAlign: 'center', margin: '5px 0' }}>{event.title}</h2>
        <p style={{ textAlign: 'justify', margin: '5px 0' }}>{event.description}</p>
        <p style={{ margin: '5px 0' }}>
          <strong>Event Fee:</strong> {event.fee}
        </p>
        <p style={{ margin: '5px 0' }}>
          <strong>Participation Type:</strong> {event.participationType}
        </p>
        <p style={{ margin: '5px 0' }}>
          <strong>Max Team Size:</strong> {event.maxTeamSize}
        </p>
        <p style={{ margin: '5px 0' }}>
          <strong>Date and Time</strong> {event.dateTime}
        </p>
        {event.languages && <p style={{ margin: '5px 0' }}>
          <strong>Programming Languages:</strong> {event.languages}
        </p>}
        {!isTimeExpired && (
          <Link to={event.register}>
            <button className="register-button" style={buttonStyle}>
              Register
            </button>
          </Link>
        )}
        {isTimeExpired && (
          <Link to="/">
            <button className="register-button" style={{ ...buttonStyle, backgroundColor: 'grey' }}>
              Registrations Closed
            </button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default Event;
